import { EventCheckout } from 'store/api/event';

export const calculateDifferenceExchangeAndCheckoutItems = (
  exchange: EventCheckout
) => {
  const itemsAmount = exchange?.items
    ?.filter((item) => !item.isExchange)
    .reduce((acc, value) => acc + +value.price * value.quantity, 0);

  return itemsAmount - Math.abs(exchange?.exchangeItemsAmount ?? 0);
};
